export enum EMedicalSpecialtyStatus {
  Completed = 'CONCLUIDO',
  InProgress = 'EM_ANDAMENTO',
}
